// extracted by mini-css-extract-plugin
export default {"text":"ChildrenModeSpaceGreeting_text__1uvQ7"};